/** Must match folders under `src/assets/temp/` and optional `proposalTemplateKey` on Location. */
export const PROPOSAL_TEMPLATE_KEYS = ["gec", "kbt", "sw"];

export const PROPOSAL_TEMPLATE_OPTIONS = [
  { value: "", name: "Default (legacy slides)" },
  ...PROPOSAL_TEMPLATE_KEYS.map((k) => ({ value: k, name: k.toUpperCase() })),
];
